import { Delete, Edit } from "@mui/icons-material";
import dayjs from "dayjs";
import React from "react";

const handleFullScreen = (image) => {
  if (image && image.includes('http')) {
    window.open(image, "_blank");
  }
};
const CreativesDragAndDropList = ({ promotionsList, handleDelete, handleEdit, IsAdmin, type }) => {
  
  return (
    <table className="min-w-full divide-y divide-gray-300" style={{ width: "100%" }}>
      <thead className="bg-gray-50">
        <tr>
          <th
            scope="col"
            className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
          >
            Name
          </th>
          <th
            scope="col"
            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color text-center"
          >
            Right Board
          </th>
          <th
            scope="col"
            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color text-center"
          >
            Horizontal Flavor Board
          </th>
          
          <th
            scope="col"
            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color text-center"
          >
            Vertical Flavor Board
          </th>
          {type === "mandatory" && (
            <>
              <th
                scope="col"
                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color text-center"
              >
                Is Optional
              </th>
              <th
                scope="col"
                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color text-center"
              >
                Duration
              </th>
            </>
          )}
          <th
            scope="col"
            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color text-center"
          >
            Action
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 bg-white">
        {promotionsList?.map((i) => (
          <tr key={i?.intBannerID} className="item-container" style={{ width: '100%' }}>
            <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
              <div className="text-gray-700">{i?.vchCreativeName}</div>
            </td>
            <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
              <div className="text-gray-700 flex justify-center">
                <img
                  width="85px"
                  height="85px"
                  src={i?.vchImageURL1}
                  onError={(event) => {
                    event.target.src = "../assets/icons/notfound.png";
                    event.onerror = null;
                  }}
                  alt="The current file"
                  onClick={() => handleFullScreen(i?.vchImageURL1)}
                />
              </div>
            </td>
            <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
              <div className="text-gray-700 flex justify-center">
                <img
                  width="85px"
                  height="85px"
                  src={i?.vchImageURL2}
                  onError={(event) => {
                    event.target.src = "../assets/icons/notfound.png";
                    event.onerror = null;
                  }}
                  alt="The current file"
                  onClick={() => handleFullScreen(i?.vchImageURL2)}
                />
              </div>
            </td>
            <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
              <div className="text-gray-700 flex justify-center">
                <img
                  width="85px"
                  height="85px"
                  src={i?.vchImageURL3}
                  onError={(event) => {
                    event.target.src = "../assets/icons/notfound.png";
                    event.onerror = null;
                  }}
                  alt="The current file"
                  onClick={() => handleFullScreen(i?.vchImageURL3)}
                />
              </div>
            </td>
            {type === "mandatory" && (
              <>
                <td className="whitespace-nowrap py-1 text-sm text-gray-500 px-3 text-center">
                  <div className="text-gray-700">{i?.bitRequired ? "Yes" : "No"}</div>
                </td>
                <td className="whitespace-nowrap py-1 text-sm text-gray-500 px-3 text-center">
                  <div className="text-gray-700">
                    {i?.bitMandatory
                      ? `${dayjs(i?.dteStartDate).format("MM/DD/YYYY")} - ${dayjs(i?.dteEndDate).format("MM/DD/YYYY")}`
                      : `NA`}
                  </div>
                </td>
              </>
            )}
            <td className="whitespace-nowrap py-1 text-sm text-gray-500 px-3 text-center">
              {/* <td className="whitespace-nowrap  py-1 text-sm text-gray-500 px-3 ">
                          <div className="text-gray-700">
                              {`${dayjs(i?.dteStartDate).format(
                                  "MM/DD/YYYY"
                              )} - ${dayjs(i?.dteEndDate).format("MM/DD/YYYY")}`
                              }
                          </div>
                      </td> */}
              {i?.IsEdit ? null : (
                <span
                  style={{ cursor: "pointer" }}
                  variant="contained"
                  onClick={() => handleEdit(i)}
                  className="text-primary hover:text-primary-dark"
                >
                  <Edit />
                </span>
              )}
              {IsAdmin && (
                <span
                  style={{ cursor: "pointer" }}
                  variant="contained"
                  onClick={() => handleDelete(i)}
                  className="text-primary hover:text-primary-dark"
                >
                  <Delete />
                </span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};


export default CreativesDragAndDropList;
